export default "__VITE_ASSET__CBOOWnCg__"